const sw = {
  home: {
    biometric_label: "UTHIBITISHAJI WA UTAMBULISHO WA KIBIOMETRIKI",
    title: "Utafutaji wa Nyuso Kwa Urahisi",
    description:
      "Pakia picha ya ubora wa juu ili kulinganisha na hifadhi za dijiti za ulimwengu kwa kutumia ulinganishaji wa hali ya juu wa neva.",
    drag_drop: "Buruta na ushushe picha yako",
    file_formats: "Inasaidia RAW, JPEG, au PNG (Maks 15MB)",
    select_file: "CHAGUA FAILI KUTOKA MFUMO",
    initiate_scan: "Anza Uchunguzi wa Kisayansi",
    upload_hint: "TAFADHALI PAKIA PICHA ILI KUENDELEA",
    uploading: "Inapakia",
    searching: "Inachunguza",
    result_title: "Matokeo",
    drop_here: "Shushe picha hapa...",
    billion_faces: "Linganisha na zaidi ya bilioni 1 ya nyuso mtandaoni",
    login_to_search: "Ingia ili kutafuta",
    login_required: "Ingia au unda akaunti ili kutumia programu hii",
    not_enough_tokens: "Tokeni haitoshi",
    please_wait: "Tafadhali subiri dakika chache",
    leave_confirmation:
      "Kuna mchakato unaoendelea. Je, una uhakika unataka kuondoka?",
  },
  sources: {
    section_title: "Vyanzo Tunavyotafuta",
    social_media: {
      name: "Mitandao ya Kijamii",
      description:
        "Marejeo ya msalaba kwenye mitandao ya kijamii makubwa na maelezo ya umma.",
    },
    web: {
      name: "Mtandao",
      description:
        "Inachunguza mtandao wazi kwa data ya uso inayopatikana hadharani.",
    },
    scammers: {
      name: "Walaghai",
      description:
        "Inalinganisha na hifadhidata za utambulisho wa walaghai wanaojulikana.",
    },
    sexual_offenders: {
      name: "Wahalifu wa Ngono",
      description:
        "Marejeo ya msalaba na rejista za umma za wahalifu waliosajiliwa.",
    },
    videos: {
      name: "Video",
      description:
        "Hutoa na kulinganisha nyuso kutoka majukwaa ya video ya umma.",
    },
    police_photos: {
      name: "Picha za Polisi",
      description:
        "Inalinganisha na hifadhidata za rekodi za polisi zinazopatikana hadharani.",
    },
    news_and_blogs: {
      name: "Habari na Blogu",
      description:
        "Inatafuta katika hifadhi za habari, maudhui ya uhariri na blogu.",
    },
  },
  header: {
    scan: "CHUNGUZA",
    history: "HISTORIA",
    pricing: "BEI",
    account: "AKAUNTI",
    logout: "TOKA",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. Haki zote zimehifadhiwa. Uthibitishaji wa Utambulisho wa Usahihi.",
    privacy: "Sera ya Faragha",
    terms: "Masharti ya Huduma",
    docs: "Hati",
    support: "Msaada",
  },
  common: {
    loading: "Inapakia...",
    error: "Hitilafu",
    cancel: "Ghairi",
    back: "Rudi",
  },
  errors: {
    upload_failed: "Upakiaji umeshindwa. Tafadhali jaribu tena.",
    not_enough_tokens: "Huna tokeni za kutosha kufanya utafutaji huu.",
  },
  login: {
    disclaimer:
      "Unahitaji akaunti ili kutumia programu hii. Hatutumi barua taka wala kushiriki barua pepe yako. Tunapendekeza kuingia kwa kutumia Apple ili kulinda faragha yako.",
  },
  results: {
    input_source: "CHANZO CHA INGIZO",
    match_thumbnail: "Kijipicha cha ulinganifu",
    extraction_id: "NAMBARI YA UCHIMBAJI",
    scan_analysis: "Uchambuzi wa Skanning",
    scan_description:
      "Utafutaji wa nyuma wa kibiolojia umekamilika. Matokeo %{count} yanayowezekana yamepatikana katika rejista za umma na faharisi za kijamii.",
    col_identity_map: "RAMANI YA UTAMBULISHO",
    col_verification_path: "NJIA YA UTHIBITISHO",
    col_bio_match_score: "ALAMA YA MECHI YA BIO",
    col_action: "HATUA",
    export_pdf: "Hamisha PDF",
    exporting: "Inazalisha...",
    verified: "IMETHIBITISHWA",
    details: "MAELEZO",
    details_tooltip: "Endesha ulinganishaji wa uso wa usahihi",
    details_loading: "Inalinganisha...",
    copied: "Imenakiliwa!",
    copy_url: "Nakili URL",
    displaying: "Inaonyesha %{count} kati ya %{total} zinazotambuliwa",
  },
};

export default sw;
